import React from 'react';
import { useStyles } from './Stamp.styles';
import { StampColor, useComponentDefaultProps } from '../../theming';
import { Styler, StylerBaseProps } from '../Styler';

export interface StampProps extends StylerBaseProps {
    /**
     * The content of the component.
     */
    children: React.ReactNode;

    /**
     * The colour of the stamp.
     * @default neutral
     */
    color?: StampColor;
}

const defaultProps: Partial<StampProps> = {
    color: 'neutral',
};

/**
 * This component represents the children which is passed to it as a Stamp. It take the input and the
 * color prop to dictate the color of the stamp and displays the content as a stamp of that given colour.
 */

export function Stamp(props: Readonly<StampProps>): React.JSX.Element {
    const { children, color = 'neutral', ref, ...other } = useComponentDefaultProps('Stamp', defaultProps, props);

    const { styles } = useStyles({ color });

    return (
        <Styler ref={ref} baseStyles={styles.root} {...other}>
            {children}
        </Styler>
    );
}
